// extracted by mini-css-extract-plugin
export default {"SliderWrapper":"njI6WTIGUJvAwT0k9N4n"};